import React, { useState, useEffect } from 'react';
import { getRecommendations, RecommendationsResponse } from '../../services/api';

interface ParentRecommendationsProps {
  studentId: string;
}

export const ParentRecommendations: React.FC<ParentRecommendationsProps> = ({ studentId }) => {
  const [data, setData] = useState<RecommendationsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    getRecommendations(studentId)
      .then(setData)
      .catch((err) => setError(err.response?.data?.detail || 'Failed to load recommendations'))
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading) return <div className="panel-loading">Loading recommendations...</div>;
  if (error) return <div className="panel-error">{error}</div>;
  if (!data || data.recommendations.length === 0) {
    return <div className="panel-empty">No recommendations available at this time.</div>;
  }

  const typeIcon = (type: string) => {
    switch (type) {
      case 'complete_reviews': return '\u{1F4DA}';
      case 'struggling_lo': return '\u{1F3AF}';
      case 'gate_prep': return '\u{1F6AA}';
      case 'new_content': return '\u{2728}';
      case 'challenge_mode': return '\u{1F3C6}';
      default: return '\u{1F4A1}';
    }
  };

  return (
    <div className="parent-recommendations">
      <div className="recommendations-list">
        {data.recommendations.map((rec, i) => (
          <div key={i} className="recommendation-item">
            <div className="rec-icon">{typeIcon(rec.type)}</div>
            <div className="rec-content">
              <div className="rec-title">{rec.title}</div>
              <div className="rec-description">{rec.description}</div>
              <div className="rec-meta">
                <span className="rec-time">{rec.estimated_time_minutes} min</span>
                <span className="rec-priority">Priority: {rec.priority}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
